<template>

	<div>
		<preloader-view v-if="isLoadingInitial"></preloader-view>

		<div v-else>
			<div class="styled-form__header white-box o-v-rhythm--small text--center">

				<div v-if="isLoading" class="styled-form__overlay">
					<div class="preloader"></div>
				</div>

				<global-message v-if="message" v-bind="message"></global-message>

				<h3 class="styled-form__subtitle bottom-gap-md">
          Manage your subscriptions by selecting your communication preferences below.
          Use the general settings to opt-in or opt-out of communications from Football Australia.
        </h3>

			</div>
        <div class="styled-form__header white-box o-v-rhythm--small text--center">
          <h3 class="styled-form__subtitle bottom-gap-md">
            If an error occurs, please email <a href="mailto:privacy@footballaustralia.com.au">privacy@footballaustralia.com.au</a> with your unsubscribe request.
          </h3>
        </div>

			<div
				:class="[
					'white-box',
					'o-v-rhythm',
					'styled-form',
					{'is-loading': isLoading}
				]"
			>

				<div v-if="isLoading" class="styled-form__overlay">
					<div class="preloader"></div>
				</div>

				<global-message v-if="errors.global" :value="errors.global"></global-message>

        <div :class="['tiles-form-group']">
          <h2 class="common__heading bottom-gap-lg">Communications</h2>

          <checkboxes-form-group
              :checkboxes="disableCommunicationGroup.checkboxes"
              :groupheading="disableCommunicationGroup.heading"
              group-name="disableCommunicationGroup"
              :clickHandler="checkboxClickHandler"
          ></checkboxes-form-group>
        </div>

        <div class="recaptcha-container">
          <div class="recaptcha-wrapper"
               v-bind:class="{'recaptcha-wrapper-invalid' : (errors.recaptcha && errors.recaptcha.length)}">
            <vue-recaptcha
                ref="recaptcha"
                :size="reCaptchaSize"
                :loadRecaptchaScript="true"
                badge= 'inline'
                sitekey="6Lc4yaEgAAAAAGP_BEXyHbJYYwuC-t0d-hHfu3l_"
                @verify="onCaptchaVerified"
                @expired="onCaptchaExpired">
            </vue-recaptcha>
          </div>
          <label for="recaptcha" class="styled-form__error is-visible recaptcha-error"
                 v-if="errors.recaptcha"
                 :error="errors.recaptcha">Please verify you are not a robot.
          </label>
        </div>

				<div class="text--center">
					<button
						type="button"
						class="btn"
						@click.prevent="onSubmit"
					>Submit</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { cloneDeep } from 'lodash';
	import { mapState, mapGetters } from 'vuex';
	import PreloaderView from '../views/PreloaderView.vue';
	import TilesFormGroup from '../formGroups/TilesFormGroup.vue';
	import CheckboxesFormGroup from '../formGroups/CheckboxesFormGroup.vue';
	import DisableCommunicationsGroup from '../formGroups/DisableCommunicationsGroup.vue';
	import GlobalMessage from '../messages/GlobalMessage.vue';
	import Checkbox from '../formFields/Checkbox.vue';
	import SlideDown from '../animations/SlideDown.vue';
	import api from "../../api";
  import VueRecaptcha from 'vue-recaptcha';

	export default {
    components: {
      GlobalMessage,
      PreloaderView,
      TilesFormGroup,
      CheckboxesFormGroup,
      DisableCommunicationsGroup,
      Checkbox,
      VueRecaptcha,
      SlideDown
    },
    props: {
      contactId: {
        type: String
      }
    },
    data() {
      return {
        destroyData: true,
        stateCopy: null,
        isLoadingInitial: false,
        recaptchaToken: '',
        reCaptchaSize: '',
        isLoading: false,
        errors: {},
        skipErrors: {},
        message: {}
      }
    },
    computed: {
      ...mapGetters('onboarding', [
        'leagueGroupChecked',
        'priorityTicketingIsChecked',
        'checkboxGroupChecked',
        'grassrootsGroupChecked',
      ]),
      ...mapState('onboarding', {
        onboardingState: state => state,
        form: state => state.form || {},
        leagueGroup: state => state.formGroups.leagueGroup,
        grassrootsGroup: state => state.formGroups.grassrootsGroup,
        priorityTicketingCheckbox: state => state.formGroups.priorityTicketing,
        checkboxGroup: state => state.formGroups.checkboxGroup,
        disableCommunicationGroup: state => state.formGroups.disableCommunicationGroup,
        // deletePreferences: state => state.formGroups.deletePreferences
      }),
      subscriptions() {
        const leagueSubscriptions = this.leagueGroupChecked.map(league => ({
          'ffa_name': league.id,
          'statecode': 0,
          'ffa_membershipstatus': true
        }));

        const otherSubscriptions = this.checkboxGroupChecked.map(checkbox => ({
          'ffa_name': checkbox.id,
          'statecode': 0,
          'ffa_membershipstatus': true
        }));

        const grassrootsSubscriptions = this.grassrootsGroupChecked.map(checkbox => ({
          'ffa_name': checkbox.id,
          'statecode': 0,
          'ffa_membershipstatus': true
        }));

        const resultArray = [
          ...grassrootsSubscriptions,
          ...leagueSubscriptions,
          ...otherSubscriptions
        ];

        if (this.priorityTicketingIsChecked) {
          resultArray.push({
            'ffa_name': this.priorityTicketingCheckbox.checkboxes[0].id,
            'statecode': 0,
            'ffa_membershipstatus': true
          });
        }

        return resultArray;
      },
      otherSettings() {
        const otherSettings = {};

        this.disableCommunicationGroup.checkboxes.forEach(setting => {
          otherSettings[setting.name] = setting.isChecked;
        });

        return otherSettings;
      }
    },
    created() {
      // if (!Object.keys(this.form).length) {
      //   this.isLoadingInitial = true;
      //
      //   let userDetails = {
      //     cid: this.contactId
      //   };

        // this.$store.dispatch('onboarding/GET_SUBSCRIPTIONS', userDetails).then(() => {
        //   this.isLoadingInitial = false;
        //   this.copyState();
        // }).catch(errors => {
        //   this.errors = errors;
        //   this.isLoadingInitial = false;
        //
        //   if (errors instanceof Error) {
        //     // console.error(errors);
        //   }
        // });
      // } else {
      //   this.copyState();
      // }
    },
    beforeDestroy() {
      if (this.destroyData) {
        this.$store.commit('onboarding/UPDATE_STATE', this.stateCopy);
      }
    },
    beforeMount() {
      if (window.innerWidth > 480) {
        this.reCaptchaSize = "normal";
      } else {
        this.reCaptchaSize = "compact";
      }
    },
    methods: {
      copyState() {
        this.stateCopy = cloneDeep(this.onboardingState);
      },
      checkboxClickHandler(groupName, checkboxIndex) {
        this.$store.commit('onboarding/TOGGLE_CHECKBOX_STATE', {groupName, checkboxIndex});
      },
      redirectAfterSubmit() {
        this.isLoading = false;
        this.destroyData = false;

        this.$router.push({
          name: 'myAccount',
          params: {
            message: {
              type: 'success',
              value: 'Your preferences were successfully updated.'
            }
          }
        });
      },
      onSubmit() {
        this.errors = this.validate(this.recaptchaToken);

        if (Object.keys(this.errors).length === 0) {
          this.updateOnboardingData();
        }
      },
      validate(recaptchaToken) {
        const errors = {};

        let recaptchaError = this.validateRecaptcha(recaptchaToken);
        if (recaptchaError.length) {
          errors.recaptcha = recaptchaError;
        }
        return errors;
      },
      updateOnboardingData() {
        let payload = {
          "ffa_donotbulkemail": this.otherSettings.ffa_donotbulkemail,
          "ffa_donotbulkmobile": this.otherSettings.ffa_donotbulkmobile,
        }

        this.isLoading = true;

        let userDetails = {
          cid: this.contactId,
          ...payload
        };
        api.crm.updateSubscriptions(userDetails)
            .then((updatedData) => {
              this.$store.dispatch('onboarding/UPDATE_ONBOARDING_STATE', updatedData)
              // this.deletePreferences.checkboxes[0].isChecked = false
              window.scrollTo(0, 0);
              this.message = {
                type: 'success',
                value: 'Your preferences were successfully updated.'
              };
              this.isLoading = false;
            })
            .catch((err) => {
              window.scrollTo(0, 0);
              this.isLoading = false;
              this.errors = {global: "Something went wrong trying to update your preferences."};
              // console.info("err", err);
            });
      },
      validateRecaptcha(token) {

        let recaptchaError = '';
        if (!token.length) {
          recaptchaError = "Please let us know that you are a human."
        }
        return recaptchaError;
      },
      onCaptchaVerified: function (recaptchaToken) {
        this.recaptchaToken = recaptchaToken;
        let validate = this.validateRecaptcha(recaptchaToken);
        if (validate.length) {
          this.errors.recaptcha = validate;
        } else {
          this.errors.recaptcha = '';
        }
      },
      onCaptchaExpired: function () {
        this.$refs.recaptcha.reset();
        this.data.recaptchaToken = "";
      }
    }
  };
</script>
